webpackJsonp([9],{

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29364b88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

// @flow

/* harmony default export */ __webpack_exports__["default"] = ({
  metaInfo: {
    title: 'Page Not Found | hybridash-v2'
  }
});

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"NotFound.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(894);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("116bd230", content, true, {});

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "display-2 primary--text pa-3"
  }, [_vm._v("Whoops, 404!")]), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_vm._v("The page you were looking for is temporarily unavailable or does not exist.")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/",
      "color": "primary",
      "outline": ""
    }
  }, [_vm._v("Get me out of here!")])], 1)])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.5259438e6d6a400d688c.js